<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JfNWQF/tc-custom/9781497652699.jpg?1706068652216" alt="This image is the cover for the book Playing Catch-Up, The Sheriff Chick Charleston Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Playing Catch-Up, The Sheriff Chick Charleston Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A ruthless killer preys on the young women of Montana in this tale of suspense from a pioneer of Western fiction</b><br/><br/> Madame Simone runs a brothel on the outskirts of Overthrust, Montana, an oil town just down the road from the ranching community of Midbury. Her business is serene, discreet, and profitable—until one of her girls is murdered.<br/>  <br/> When his other deputies fail to turn up any leads, Sheriff Chick Charleston asks his college-educated colleague Jason Beard to look into the case. Jase immediately uncovers two vital clues: a mysterious stranger who publicly threatened Laura Jane on the night she was killed and a beloved piece of jewelry missing from her personal effects. Just when Charleston and Jase begin to think they are making progress, however, a teenage girl dies under frighteningly similar circumstances.<br/>  <br/> To find the culprit, the sheriff and his deputy must be patient, cunning, and resourceful. Set against the backdrop of a land whose rugged beauty and vast open spaces attract dreamers and criminals alike, <i>Playing Catch-Up </i>is an engrossing detective story and a tribute to the unique adventure of small-town life in the West.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A. B. Guthrie
      </h2>
      
      <p class="authorDescription body article">A. B. Guthrie Jr. (1901&ndash;1991) was an award-winning American novelist, screenwriter, historian, and environmentalist. Born in Indiana, he was six months old when his father brought the family west to the Montana territory. Guthrie graduated from the University of Montana with a degree in journalism and worked as a reporter and editor for two decades before receiving a Nieman fellowship from Harvard University. During his grant year, he began to seriously pursue his interest in writing fiction. His first major novel,&#160;<I>The Big Sky&#160;</I>(1947), was followed by the Pulitzer Prize&ndash;winning&#160;<I>The Way West&#160;</I>(1949). Guthrie&rsquo;s popular mystery series featuring Montana sheriff Chick Charleston earned a Silver Spur Award from the Western Writers of America and an award from the National Cowboy &amp; Western Heritage Museum. The five books in the series are&#160;<I>Wild Pitch&#160;</I>(1973),&#160;<I>The Genuine Article&#160;</I>(1977),&#160;<I>No Second Wind&#160;</I>(1980),&#160;<I>Playing Catch-Up&#160;</I>(1985), and&#160;<I>Murder in the Cotswolds&#160;</I>(1989). In 1954 Guthrie&rsquo;s screenplay for the film&#160;<I>Shane</I>&#160;was nominated for an Academy Award.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?14cc56ad